export default "__VITE_ASSET__e4ce8f94__"